export const ROLE_TEMPLATE_LITERAL = '{role}';
//# sourceMappingURL=types.js.map